import { render } from "./CarouselPinnedContent.vue?vue&type=template&id=2a41aa80&scoped=true"
import script from "./CarouselPinnedContent.vue?vue&type=script&lang=js"
export * from "./CarouselPinnedContent.vue?vue&type=script&lang=js"

import "./CarouselPinnedContent.vue?vue&type=style&index=0&id=2a41aa80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a41aa80"]])

export default __exports__